import React from 'react';
import { getLocalDate } from 'common/utils';
import { Typography } from 'e100-react-components';
import IconedPanel from 'components/IconedPanel';

import { useSelectedCar } from 'features/myFleet';

export const ActiveServices = () => {
  const selectedCar = useSelectedCar();

  if (!selectedCar || !selectedCar.serviceActivationOnOBU || !selectedCar.serviceActivationOnOBU.serviceActive) {
    return null;
  }

  const serviceActive = selectedCar.serviceActivationOnOBU.serviceActive;
  const updateDate = getLocalDate(serviceActive.timestamp);

  return (
    <>
      {serviceActive.value
        .filter((x) => x.name)
        .map(({ id, name }) => (
          <IconedPanel
            icon="signal"
            title={name}
            subtitle={<><Typography display="inline" paragraph={false} color="primary" variant='caption'>{'Active: '}</Typography>{`updated ${updateDate}`}</>}
            gutterBottom={1}
            alignItems={'center'}
            subtitleVariant={'caption'}
          />
        ))}
    </>
  );
};
